/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ServiceTypeSlugEnum = (typeof ServiceTypeSlugEnum)[keyof typeof ServiceTypeSlugEnum];

export const ServiceTypeSlugEnum = {
  'dog-boarding': 'dog-boarding',
  'house-sitting': 'house-sitting',
  'dog-walking': 'dog-walking',
  'pet-sitting': 'pet-sitting',
  'cat-sitting': 'cat-sitting',
  'doggy-day-care': 'doggy-day-care',
  'dog-training': 'dog-training',
  'dog-sitting': 'dog-sitting',
  'pet-boarding': 'pet-boarding',
} as const;
